// Copyright (c) 2019 Comsearch, Inc., All rights reserved

import styled from 'styled-components'

// visually hides the radio element but leaves it still a11y compliant.
export const Input = styled.input`
  left: -999vw;
  position: fixed;
`

export const Label = styled.label`
  cursor: pointer;
  margin-top: 1em;
  user-select: none;

  input:disabled + & {
    cursor: not-allowed;
    opacity: .5
  }
`

export const UpdatedCheckboxGroupWrapper = styled.div`
  align-items: flex-start;
  display: flex;
  flex-direction: column;
`
